import React, {useState} from 'react';
// @ts-ignore
import Slider from 'react-slick';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import '../Assets/css/ClienteHome.css';
import {NextArrow, PrevArrow} from "./ui/CustomArrow";

import Cliente1 from '../Assets/img/LogosEmpresas/Confian-01.jpg';
import Cliente2 from '../Assets/img/LogosEmpresas/Confian-02.jpg';
import Cliente3 from '../Assets/img/LogosEmpresas/Confian-03.jpg';
import Cliente4 from '../Assets/img/LogosEmpresas/Confian-04.jpg';
import Cliente5 from '../Assets/img/LogosEmpresas/Confian-05.jpg';
import Cliente6 from '../Assets/img/LogosEmpresas/Confian-06.jpg';
import Cliente7 from '../Assets/img/LogosEmpresas/Confian-07.jpg';
import Cliente8 from '../Assets/img/LogosEmpresas/Confian-08.jpg';
import Cliente9 from '../Assets/img/LogosEmpresas/Confian-09.jpg';
import Cliente10 from '../Assets/img/LogosEmpresas/Confian-10.jpg';
import Cliente11 from '../Assets/img/LogosEmpresas/Confian-11.jpg';
import Cliente12 from '../Assets/img/LogosEmpresas/Confian-12.jpg';
import Cliente13 from '../Assets/img/LogosEmpresas/Confian-13.jpg';
import Cliente14 from '../Assets/img/LogosEmpresas/Confian-14.jpg';
import Cliente15 from '../Assets/img/LogosEmpresas/Confian-15.jpg';
import Cliente16 from '../Assets/img/LogosEmpresas/Confian-16.jpg';
import Cliente17 from '../Assets/img/LogosEmpresas/Confian-17.jpg';
import Cliente18 from '../Assets/img/LogosEmpresas/Confian-18.jpg';
import Cliente19 from '../Assets/img/LogosEmpresas/Confian-19.jpg';
import Cliente20 from '../Assets/img/LogosEmpresas/Confian-20.jpg';
import Cliente21 from '../Assets/img/LogosEmpresas/Confian-21.jpg';

const clientesArray = [
    {imagen: Cliente1, url: 'https://www.google.com'},
    {imagen: Cliente2, url: 'https://www.google.com'},
    {imagen: Cliente3, url: 'https://www.google.com'},
    {imagen: Cliente4, url: 'https://www.google.com'},
    {imagen: Cliente5, url: 'https://www.google.com'},
    {imagen: Cliente6, url: 'https://www.google.com'},
    {imagen: Cliente7, url: 'https://www.google.com'},
    {imagen: Cliente8, url: 'https://www.google.com'},
    {imagen: Cliente9, url: 'https://www.google.com'},
    {imagen: Cliente10, url: 'https://www.google.com'},
    {imagen: Cliente11, url: 'https://www.google.com'},
    {imagen: Cliente12, url: 'https://www.google.com'},
    {imagen: Cliente13, url: 'https://www.google.com'},
    {imagen: Cliente14, url: 'https://www.google.com'},
    {imagen: Cliente15, url: 'https://www.google.com'},
    {imagen: Cliente16, url: 'https://www.google.com'},
    {imagen: Cliente17, url: 'https://www.google.com'},
    {imagen: Cliente18, url: 'https://www.google.com'},
    {imagen: Cliente19, url: 'https://www.google.com'},
    {imagen: Cliente20, url: 'https://www.google.com'},
    {imagen: Cliente21, url: 'https://www.google.com'}
];

export const NewClientesHome = () => {
    //

    const [clientes, setClientes] = useState(clientesArray);
    const  [titulo_empresa, setTitulo_empresa] = useState('');

    const sliderSettings = {
        infinite: true,
        speed: 500,
        slidesToShow: 5,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 2000,
        nextArrow: <NextArrow />,
        prevArrow: <PrevArrow />,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3,
                    infinite: true,
                    dots: true
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2
                }
            }
        ]
    };

    return (
        <section className="clientes-container">
            <div className="container">
                <h1
                    style={{
                        textAlign: 'center',
                        fontSize: '50px',
                        paddingBottom: '10px',
                        fontWeight: 'bold',
                        lineHeight: 'normal'
                    }}
                >
                    Confían en nosotros
                </h1>

                <div className="slider-cliente-container">
                    <Slider {...sliderSettings}>
                        {clientes.map((cliente, index) => (
                            <div className="cubo-cliente" key={index}>
                                <a href={cliente.url} target="_blank" rel="noopener noreferrer">
                                    <img
                                        className="cliente-logo"
                                        src={cliente.imagen}
                                        alt={cliente.imagen}
                                    />
                                </a>
                            </div>
                        ))}
                    </Slider>
                </div>
            </div>
        </section>
    );
};
